import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import PrimeVue from 'primevue/config'
import ToastService from 'primevue/toastservice'
import ConfirmationService from 'primevue/confirmationservice'
import axios from 'axios'

// Configuration d'Axios
axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL || 'https://api.rayuwa.net/'
axios.defaults.withCredentials = true

// Initialisation du token d'authentification
const token = localStorage.getItem('token')
if (token) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
}

// Intercepteur pour gérer les erreurs d'authentification
axios.interceptors.response.use(
  response => response,
  error => {
    if (error.response) {
      const { status, data } = error.response;
      
      // Seulement déconnecter pour les erreurs d'authentification réelles (401)
      // Les erreurs 403 (permissions) ne doivent PAS déconnecter l'utilisateur
      if (status === 401) {
        // Token expiré ou invalide - déconnexion forcée
        store.dispatch('auth/logout');
        router.push('/login');
      }
      // Pour les erreurs 403 (permissions), on laisse le composant gérer l'affichage
      // L'utilisateur reste connecté et peut voir le message d'erreur
    }
    return Promise.reject(error);
  }
)

// PrimeVue components
import Button from 'primevue/button'
import Dialog from 'primevue/dialog'
import Menu from 'primevue/menu'
import Menubar from 'primevue/menubar'
import Toast from 'primevue/toast'
import ConfirmDialog from 'primevue/confirmdialog'
import InputText from 'primevue/inputtext'
import Password from 'primevue/password'
import Checkbox from 'primevue/checkbox'

// Styles
import 'primevue/resources/themes/lara-light-green/theme.css'
import 'primevue/resources/primevue.min.css'
import 'primeicons/primeicons.css'
import './assets/styles/main.scss'

const app = createApp(App)

// Use plugins
app.use(store)
app.use(router)
app.use(PrimeVue, { ripple: true })
app.use(ToastService)
app.use(ConfirmationService)

// Register components
app.component('PButton', Button)
app.component('PDialog', Dialog)
app.component('PMenu', Menu)
app.component('PMenubar', Menubar)
app.component('PToast', Toast)
app.component('PConfirmDialog', ConfirmDialog)
app.component('PInputText', InputText)
app.component('PPassword', Password)
app.component('PCheckbox', Checkbox)

app.mount('#app') 